export default "__VITE_ASSET__DrvmRJd2__"